'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    en = function en(n, ord) {
  var s = (n + '').split('.'),
      v0 = !s[1],
      t0 = +s[0] == n,
      n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2);
  return ord ? 1 == n10 && 11 != n100 ? 'one' : 2 == n10 && 12 != n100 ? 'two' : 3 == n10 && 13 != n100 ? 'few' : 'other' : 1 == n && v0 ? 'one' : 'other';
},
    plural = function plural(value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  offset && (value -= offset);
  var key = lcfunc(value, isOrdinal);
  return key in data ? data[key] : data.other;
},
    fmt = {
  number: function number(value, lc, arg) {
    var a = arg && arg.split(':') || [],
        opt = {
      integer: {
        maximumFractionDigits: 0
      },
      percent: {
        style: 'percent'
      },
      currency: {
        style: 'currency',
        currency: a[1] && a[1].trim() || 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    };
    return new Intl.NumberFormat(lc, opt[a[0]] || {}).format(value);
  }
};

(function (root, G) {
  'function' == typeof define && define.amd ? define(G) : 'object' === ('undefined' == typeof exports ? 'undefined' : _typeof(exports)) ? module.exports = G : root.vstuiLocaleData = G;
})(void 0, {
  locale: 'en',
  direction: 'ltr',
  messages: {
    button: {
      newWindowWarning: function newWindowWarning(d) {
        return d.link + ' (opens in a new window)';
      }
    },
    dialog: {
      closeButton: function closeButton() {
        return 'Close';
      }
    },
    form: {
      badInputDatetime: function badInputDatetime() {
        return 'Please enter a valid value. The field is incomplete or has an invalid date.';
      },
      badInputNumber: function badInputNumber() {
        return 'Please enter a valid number.';
      },
      badLength: function badLength(d) {
        return d.changeCharacters + ' (' + d.currentlyUsingCharacters + ').';
      },
      missingCheckbox: function missingCheckbox() {
        return 'Please check this box if you want to proceed.';
      },
      missingEmail: function missingEmail() {
        return 'Please enter an email address.';
      },
      missingFile: function missingFile() {
        return 'Please select a file.';
      },
      missingNumber: function missingNumber() {
        return 'Please enter a number.';
      },
      missingPassword: function missingPassword() {
        return 'Please enter a password.';
      },
      missingRadio: function missingRadio() {
        return 'Please select one of these options.';
      },
      missingSelect: function missingSelect() {
        return 'Please select an item in the list.';
      },
      missingTel: function missingTel() {
        return 'Please enter a telephone number.';
      },
      missingText: function missingText() {
        return 'Please fill out this field.';
      },
      missingUrl: function missingUrl() {
        return 'Please enter a URL.';
      },
      patternMismatch: function patternMismatch() {
        return 'Please match the requested format.';
      },
      rangeOverflow: function rangeOverflow(d) {
        return 'Value must be less than or equal to ' + fmt.number(d.max, 'en') + '.';
      },
      rangeOverflowDatetime: function rangeOverflowDatetime(d) {
        return 'Value must be ' + d.date + ' or earlier.';
      },
      rangeUnderflow: function rangeUnderflow(d) {
        return 'Value must be greater than or equal to ' + fmt.number(d.min, 'en') + '.';
      },
      rangeUnderflowDatetime: function rangeUnderflowDatetime(d) {
        return 'Value must be ' + d.date + ' or later.';
      },
      stepMismatch: function stepMismatch(d) {
        return 'Please enter a valid value. The two nearest valid values are ' + d.value1 + ' and ' + d.value2 + '.';
      },
      stepMismatchOneValue: function stepMismatchOneValue(d) {
        return 'Please enter a valid value. The nearest valid value is ' + d.value + '.';
      },
      typeMismatchEmail: function typeMismatchEmail() {
        return 'Please enter a valid email address.';
      },
      typeMismatchUrl: function typeMismatchUrl() {
        return 'Please enter a valid URL.';
      },
      shortenCharacters: function shortenCharacters(d) {
        return plural(d.quantity, 0, en, {
          one: 'Please shorten this text to ' + fmt.number(d.quantity, 'en', 'integer') + ' character or less',
          other: 'Please shorten this text to ' + fmt.number(d.quantity, 'en', 'integer') + ' characters or less'
        });
      },
      lengthenCharacters: function lengthenCharacters(d) {
        return plural(d.quantity, 0, en, {
          one: 'Please use at least ' + fmt.number(d.quantity, 'en', 'integer') + ' character',
          other: 'Please use at least ' + fmt.number(d.quantity, 'en', 'integer') + ' characters'
        });
      },
      currentlyUsingCharacters: function currentlyUsingCharacters(d) {
        return plural(d.quantity, 0, en, {
          one: 'you are currently using ' + fmt.number(d.quantity, 'en', 'integer') + ' character',
          other: 'you are currently using ' + fmt.number(d.quantity, 'en', 'integer') + ' characters'
        });
      }
    },
    table: {
      sortedAscending: function sortedAscending(d) {
        return 'Sorted in ascending order by ' + d.columnHeader;
      },
      sortedDescending: function sortedDescending(d) {
        return 'Sorted in descending order by ' + d.columnHeader;
      }
    }
  },
  version: '1.3.0'
});